<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.name="{ data, value: v }">
      <a
        :href="`#/roadmap/directions/${data.id}`"
        @click="onView(data)"
        v-text="v"
      />
    </template>

    <template #item.is_confirmed="{ value: v }">
      <v-icon v-if="v" color="success">
        mdi-checkbox-marked-outline
      </v-icon>
    </template>

    <template #item.is_required="{ value: v }">
      <v-icon v-if="v" color="success">
        mdi-checkbox-marked-outline
      </v-icon>
      <v-icon v-else color="gray">
        mdi-checkbox-blank-outline
      </v-icon>
    </template>

    <template v-for="(_, key) in $scopedSlots" #[key]="props">
      <slot v-bind="props" :name="key" />
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/Roadmaps/Directions/table-headers'
import { VIEW } from '@/helpers/enums/view-types'

import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTableRoadmapDirections',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
  methods: {
    onView(data) {
      this.$emit(`action:${VIEW}`, data)
    },
  },
}
</script>
